import Autocomplete from 'react-autocomplete'
import { CompanyUserRepository } from 'app/shared/data-access/communities/companies/company-users/company-user-repository'
import { ISearchCompanyUsersOutput } from 'app/shared/data-access/communities/companies/company-users/search-company-users/search-company-users-output'
import useDebounce from 'app/shared/utils/use-debounce'

import React, { useEffect, useState } from 'react'
import { useStyles } from './search-user.styles'

interface IAvailableUser { id: string, email: string, surname: string, communityName: string, companyName: string }

const SearchUser = () => {
    const classes = useStyles()
    const [availableUsers, setAvailableUsers] = useState<IAvailableUser[]>([])
    const [companyUsers, setCompanyUsers] = useState<ISearchCompanyUsersOutput[]>([])
    const [searchValue, setSearchValue] = useState<string>('')
    const debouncedSearchValue = useDebounce(searchValue, 500)

    useEffect(() => {
        const searchUsers = async () => {
            const response = await CompanyUserRepository.searchCompanyUsers({ email: searchValue })
            if (!response.data) {
                return
            }

            const result = response.data.map(u => {
                return {
                    id: u.id,
                    communityName: u.communityName,
                    companyName: u.companyName,
                    email: u.companyUserEmail
                } as IAvailableUser
            })

            setCompanyUsers(response.data)
            setAvailableUsers(result)
        }

        searchUsers()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearchValue])


    return (
        <div className={classes.root}>

            <Autocomplete
                inputProps={{ id: 'user-autocomplete' }}
                value={searchValue}
                wrapperStyle={{ position: 'relative', display: 'inline-block', cursor: 'pointer' }}
                items={availableUsers}
                getItemValue={(item: IAvailableUser) => item.email}
                onSelect={(value, item: IAvailableUser) => {
                    setSearchValue(value)
                    setAvailableUsers([item])

                    const companyUser = companyUsers.find(x => x.companyUserEmail === value)
                    if (!companyUser) {
                        return
                    }

                    window.location.href = `/communities/${companyUser.communityId}/companies/${companyUser.companyId}/companyusers/${companyUser.id}`
                }}
                onChange={(_event, value) => {
                    setSearchValue(value)
                }}
                renderMenu={children => (
                    <div className={classes.menu}>
                        {children}
                    </div>
                )}
                renderItem={(item: IAvailableUser, isHighlighted) => (
                    <div
                        className={isHighlighted ? classes.highligted : undefined}
                        key={item.email}
                    >
                        <div>{item.email}</div>
                        <div>{item.communityName}</div>
                        <div>{item.companyName}</div>
                        <hr></hr>
                    </div>
                )}
            />
        </div>
    )
}


export default SearchUser